import styled from '@emotion/native';
import * as theme from '@lib/theme';
import React, { FC, useState } from 'react';

import Header from '@components/1-atoms/Header';
import TitleBase from '@components/1-atoms/Title';
import IconButton from '@components/2-molecules/Buttons/IconButton';
import { Column, Spacer } from './Miscellaneous';

import { View } from 'react-native';

/* 
*/
// box-shadow: 5px 9px 6px 2px rgba(0, 0, 0, 0.25);
const Container = styled.View`
  flex-direction: column;

  background-color: #FFF;
  ${props => props?.bg && ` background-color: ${props?.bg}; `}
  ${props => !props?.noRadius && `border-radius: 6px; `}
  
  border: ${({ theme }: any) => `1px solid ${theme.pallete.gray_1}`};
  width: ${({ theme }: any) => `${Math.min(500, theme.contentWidth)}px`};
  
  overflow: hidden;
`;

const Title = styled(TitleBase)`
  padding: 0 3px;
`;


const Content = styled.View`
  align-items: center;
  flex-direction: column;
  padding: ${({ noPadding }: any) => !noPadding && `12px`};
`;


const Card: FC<CardProps> = ({ children, title, subtitle, /* onClose=null, */ onAction = null, icon, themed = true, ...props }) => {
  const [closed, setClose] = useState(false);

  // icon = icon || <Close width={20} height={20} fill={'#000'}/>;

  /* if(closed) {
    return null;
  } */
  return (
    <Container {...props}>

      {(title || onAction) ?
        <Header
          {...(themed ? theme.gradients.primary : theme.gradients.white)}
        >

          <Column>
            {subtitle ?
              <View>
                <Spacer h={.1} />
                <Title large color={themed ? "#FFF" : undefined} >
                  {title}
                </Title>
                <Spacer h={.6} />
                <Title xsmall color={themed ? "#FFF" : undefined} >
                  {subtitle}
                </Title>
                <Spacer h={.1} />
              </View>
              :
              <View>
                <Spacer h={.6} />
                <Title large bold color={themed ? "#FFF" : undefined}>
                  {title}
                </Title>
                <Spacer h={.6} />
              </View>
            }
          </Column>

          {icon && <IconButton icon={icon} onPress={() => onAction?.()} />}
        </Header>
        :
        null
      }
      <Content {...props}>
        {children}
      </Content>

    </Container>
  );
}



type CardProps = {
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
  style?: object;
  themed?: boolean;
  bg?: string;
  onClose?: any;
  onAction?: () => void;
  icon?: React.ReactNode;
  noPadding?: boolean;
  noRadius?: boolean;
};

export default Card;